import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import PictureList from "../../../../components/UI/viewDialogs/PictureList";

VisitModalLayout.VisitPictures = function VisitPictures() {
  const { pictureList, openImageSlider, setImageSliderCurrentIndex } =
    useVisitDialog();

  if (!pictureList) return null;
  return (
    <PictureList
      pictureList={pictureList}
      openImageSlider={openImageSlider}
      setImageSliderCurrentIndex={setImageSliderCurrentIndex}
    />
  );
};
